import React, { useState } from "react";
import { CheckboxInput, SelectInput } from "components/form";
import OutlinedInput from "@mui/material/OutlinedInput";

const MultipleChoiceQuestion = ({
  questionId,
  questionText,
  options,
  setFieldValue,
  hasNAOption
}) => {
  const [values, setValues] = useState("");
  const [markedAsNA, setMarkedAsNA] = useState(false);

  const setQuestionValue = e => {
    const value = e.target.value;
    const test = {
      QuestionId: questionId,
      QuestionOptionId: value,
      MarkedAsNA: false
    };
    setFieldValue(questionId, test);
    setValues(value);
  };

  const toggleNA = () => {
    const newVal = !markedAsNA;
    setMarkedAsNA(newVal);
    setValues("");
    setFieldValue(questionId, {
      QuestionId: questionId,
      QuestionOptionIdList: null,
      QuestionOptionId: null,
      MarkedAsNA: newVal
    });
  };

  return (
    <>
      <SelectInput
        name={questionId}
        options={options.map(o => ({
          text: o.Text,
          value: o.FormQuestionOptionsID
        }))}
        label={questionText}
        input={<OutlinedInput label="Tag" />}
        value={values}
        onChange={e => {
          setQuestionValue(e);
        }}
        disabled={markedAsNA}
        customLabel={
          <span id={`${questionId}-label`} className="question-container-label">
            {questionText}
          </span>
        }
      />
      {hasNAOption && (
        <CheckboxInput
          name={questionId + "N/A"}
          label="N/A"
          onChange={toggleNA}
          value={markedAsNA}
        />
      )}
    </>
  );
};

export default MultipleChoiceQuestion;
